import { render, staticRenderFns } from "./configDetailaddorupdate.vue?vue&type=template&id=2659ccd7"
import script from "./configDetailaddorupdate.vue?vue&type=script&lang=js"
export * from "./configDetailaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports